import { useState, useCallback, useRef, useEffect } from 'react';
import { httpFetch } from '../Utils/httpUtils';

const useSearch = (endpoint) => {
    const [results, setResults] = useState([]);
    const abortControllerRef = useRef(null);

    const search = useCallback((searchQuery) => {
        setResults([]);
        if (!searchQuery?.trim()) {
            return Promise.resolve();
        }

        // Cancel previous request if still pending
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        const url = `${endpoint}?searchPhrase=${searchQuery}`;
        
        return httpFetch(url, null, { signal: controller.signal })
            .then((data) => {
                const searchResults = data?.results || data || [];
                setResults(searchResults);
                abortControllerRef.current = null;
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error('Search failed:', error);
                }
                abortControllerRef.current = null;
            });
    }, [endpoint]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);
    
    return {
        search,
        results
    };
};

// Exported hook for customer search
export const useCustomerSearch = () => useSearch('/api/customer');


